/* eslint-disable max-lines-per-function */
import React, { Fragment } from 'react';

export function TimeComponent({
  flightDuration = '00:00',
  intl = {},
  direction = 'rtl',
}) {
  return (
    <Fragment>
      <div className="d-flex w-100  align-items-center justify-content-center">
        <div className="col-2 p-0 border h-0" />
        <div className="d-flex w-100 border align-items-center justify-content-center font-xsmall rounded-pill py-1 px-3 font-weight-bold text-dark">
          <span className=" d-flex px-1">
            <span className="d-flex">{`${
              parseInt(flightDuration.split(':')[0]) >= 0
                ? `${parseInt(flightDuration.split(':')[0])} `
                : ''
            }`}</span>
            <span className="d-flex">{`${
              parseInt(flightDuration.split(':')[0]) >= 0
                ? ` ${
                    direction === 'ltr'
                      ? 'h'
                      : intl.formatMessage({ id: 'booking.hour' })
                  } `
                : ''
            }`}</span>
          </span>
          <span className="d-flex px-1">
            <span className="">
              {` ${
                parseInt(flightDuration.split(':')[1]) > 0
                  ? `${parseInt(flightDuration.split(':')[1])}  `
                  : ''
              }`}
            </span>

            <span>
              {` ${
                parseInt(flightDuration.split(':')[1]) > 0
                  ? ` ${
                      direction === 'ltr'
                        ? 'm'
                        : intl.formatMessage({ id: 'booking.minutes' })
                    } `
                  : ''
              }`}
            </span>
          </span>
        </div>
        <div className="col-2 p-0  border h-0" />
      </div>
    </Fragment>
  );
}
